import { render } from "./MTBank.vue?vue&type=template&id=209588ec"
import script from "./MTBank.vue?vue&type=script&lang=js"
export * from "./MTBank.vue?vue&type=script&lang=js"

import "./MTBank.vue?vue&type=style&index=0&id=209588ec&lang=css"
script.render = render

export default script